import styled from 'styled-components';
import { ApIcon, ApMenuItem, colors } from '@alixpartners/ui-components';

export const HeaderDropdownLabelContainer = styled.button`
  height: 44px;
  border: 1px solid ${colors.grey3};
  border-radius: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background-color: ${colors.white};
  outline: none;
  ${({ disabled }) =>
    disabled
      ? `
            pointer-events: none;
        `
      : `
            cursor: pointer;
        `}
`;

export const HeaderDropdownLabelText = styled.span`
  font-size: 28px;
  color: ${colors.grey7};
  margin-right: 8px;
  white-space: nowrap;
`;

export const ApMenuItemStyled = styled(ApMenuItem)`
  display: flex;
  align-items: center;
  padding: 8px 24px 8px 12px;
  font-size: 16px;
`;

export const CheckIcon = styled(ApIcon)<{ visible?: boolean }>`
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;
